export const addOffsetDegrees = (degrees: number, offset: number) => {
  return (degrees + offset) % 360
}

export const isInDegreesRange = (degrees: number, degreesRange: [number, number], offset: number) => {
  const fixedDegrees = addOffsetDegrees(degrees, offset)
  return degreesRange[0] <= fixedDegrees && fixedDegrees <= degreesRange[1]
}
